import {
    ADD_COMMENT,
    ADD_COMMENT_ERROR,
    ADD_COMMENT_LOADING,
    GET_COMMENT, GET_COMMENT_ERROR,
    GET_COMMENT_LOADING
} from "../actions/actionTypes";


const initialState = {
    data :[],
    loading:false,
    error : null
}

export default function commentsReducer (state = initialState, action) {
    switch(action.type){
        case ADD_COMMENT_LOADING:
            return {
                ...state ,
                loading : true ,
                error : null ,
            }
        case ADD_COMMENT_ERROR:
            return {
                ...state ,
                error : action.payload
            }
        case ADD_COMMENT :
            return {
                ...state ,
                data : state.data.concat(action.payload)
            }
        case GET_COMMENT_LOADING:
            return {
                ...state ,
                loading : true ,
                error : null ,
            }
        case GET_COMMENT_ERROR:
            return {
                ...state ,
                error : action.payload
            }
        case GET_COMMENT :
            return {
                ...state ,
                data: state.data.concat(action.payload)
            }
        default: return state
    }
}

